import { getUserPreferences } from '../../v2';
import versionData from '../../getVersionData';

export default (params) => {
  const { nodeType, fieldType, fieldData } = params;

  const {
    document: { nodes: documentNodes },
  } = fieldData;

  const [fullNameNode] = documentNodes;
  const { nodes: inlineNodes } = fullNameNode;

  /**
   * Iterate through all inlines nodes and check the text present in full name
   */
  let fullNameText = '';
  inlineNodes.forEach((inlineNode) => {
    if (inlineNode.object === 'text') {
      const { leaves } = inlineNode;
      const [documentLeaf] = leaves;
      const { text } = documentLeaf;
      fullNameText += text;
    }
  });

  const updatedFullName = versionData(fieldData, 2);

  let { userPreferences } = params;
  userPreferences = getUserPreferences({
    fieldType,
    nodeType,
    fieldValue: !!fullNameText,
    userPreferences,
  });
  return { fullName: updatedFullName, userPreferences };
};
